<template>
  <div class="provider-response-forwarding">
    <div class="text-body-2 mb-1">Default communication method with prescribing provider</div>
    <v-radio-group
      :model-value="enabled ? 'email' : 'fax'"
      :disabled="disabled"
      :readonly="readonly"
      hide-details
      density="compact"
      inline
      class="mb-1"
      @update:model-value="onMethodChange">
      <v-radio label="Fax" value="fax" />
      <v-radio label="Email" value="email" />
    </v-radio-group>
    <v-text-field
      v-if="enabled"
      :model-value="email"
      label="Provider email"
      placeholder="name@clinic.com"
      type="email"
      class="lh--force-white-background"
      :readonly="readonly"
      :disabled="disabled"
      :error-messages="emailErrorMessages"
      @update:model-value="onEmailChange" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { isEmailValid } from "@/utils/validators";

const props = defineProps({
  enabled: { type: Boolean, default: false },
  email: { type: String, default: null },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  showErrors: { type: Boolean, default: false },
});

const emit = defineEmits(["update:enabled", "update:email"]);

const emailErrorMessages = computed(() => {
  if (!props.showErrors || !props.enabled) return null;
  if (!props.email || !String(props.email).trim()) {
    return "Provider email is required when forwarding responses.";
  }
  if (!isEmailValid(props.email)) {
    return "Please enter a valid email address.";
  }
  return null;
});

function onMethodChange(value) {
  emit("update:enabled", value === "email");
}

function onEmailChange(value) {
  emit("update:email", value);
}

function validate() {
  if (!props.enabled) return true;
  return Boolean(props.email && String(props.email).trim() && isEmailValid(props.email));
}

defineExpose({ validate });
</script>
